import { render, staticRenderFns } from "./VetClaimList.vue?vue&type=template&id=16fb562e&"
import script from "./VetClaimList.vue?vue&type=script&lang=js&"
export * from "./VetClaimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports